

export default  {
  // 设置
  set(key, value) {
    let val = value
    // key不符合规范时，不做操作
    if (!sessionStorage || !window.sessionStorage || !key || typeof key !== 'string') {
      return false
    }

    // value不符合规范时，存进去空字符串
    if (typeof val === undefined || val == null) {
      val = ''
    }
    // value是对象时，存进去字符串
    else if (typeof value === 'object') {
      val = JSON.stringify(value)
    }
    sessionStorage.setItem(key, val)
  },

  // 获取
  get(key) {
    // key不符合规范时，不做操作
    if (!sessionStorage || !window.sessionStorage || !key || typeof key !== 'string') {
      return false
    }
    let value = sessionStorage.getItem(key)
    if (value === 'true') {
      value = true
    } else if (value === 'false') {
      value = false
    } else if (!isNaN(Number(value))) {
      value = Number(value)
    } else {
      try {
        value = JSON.parse(value)
      } catch (e) { }
    }
    return value
  },
  // 清除某一项
  remove(key) {
    sessionStorage.removeItem(key)
  },

  // 清空
  clear() {
    sessionStorage.clear()
  },
}
